import Vue from 'vue'
import { Message } from 'element-ui'
import Clickoutside from './clickoutside'

/**
 * v-intervalclick
 * 使用方法：
 * <button v-intervalclick='{func:执行方法,time:间隔时间(毫秒数),...执行方法所需要的参数}'>点击</button>
 * **/
let openDelay = false
Vue.directive('intervalclick', function (el, binding) {
  el.onclick = function (e) {
    if (openDelay) return
    openDelay = !openDelay
    if (!binding.value) {
      Message.warning('未传入Value数据！')
      openDelay = !openDelay
      return
    }
    let func = binding.value['func']
    let time = binding.value['time']
    if (typeof time !== 'number') {
      Message.warning('传入等待时间错误')
      openDelay = !openDelay
      return
    }
    let args = []
    for (const key in binding.value) {
      if (binding.value.hasOwnProperty(key)) {
        if (key === 'func' || key === 'time') continue
        args.push(binding.value[key])
      }
    }
    let to = setTimeout(() => {
      openDelay = !openDelay
      clearTimeout(to)
    }, time)
    func(...args)
  }
})

Vue.directive('click-outside', Clickoutside)

Vue.directive('dialogDrag', {
	bind(el) {
		const dialogHeaderEl = el.querySelector('.el-dialog__header') || el.querySelector('.dialog_boss .fix-title')
		window.dragHeader_BOS = dialogHeaderEl
		const dragDom = el.querySelector('.el-dialog') || el.querySelector('.dialog_boss')
		dialogHeaderEl.style.cursor = 'move'

		// 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
		const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

		dialogHeaderEl.onmousedown = e => {
			// 鼠标按下，计算当前元素距离可视区的距离
			const disX = e.clientX - dialogHeaderEl.offsetLeft
			const disY = e.clientY - dialogHeaderEl.offsetTop

			// 获取到的值带px 正则匹配替换
			let styL, styT

			// 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
			if (sty.left.includes('%')) {
				styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
				styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
			} else {
				styL = +sty.left.replace(/\px/g, '')
				styT = +sty.top.replace(/\px/g, '')
			}

			document.onmousemove = function(e) {
				// 通过事件委托，计算移动的距离
				const l = e.clientX - disX
				const t = e.clientY - disY

				// 移动当前元素
				dragDom.style.left = `${l + styL}px`
				dragDom.style.top = `${t + styT}px`
			}

			document.onmouseup = function(e) {
				document.onmousemove = null
				document.onmouseup = null
			}
		}
	},
	unbind(el) {
		if (window.dragHeader_BOS) window.dragHeader_BOS.onmousedown = null
		document.onmousemove = null
	}
})
